import { portals, portalOrder } from './portals';
import type { PortalKey } from './types';

/** Um item do seletor de portais (link para outra solução/deploy). */
export interface PortalLink {
  id: string;
  name: string;
  sub: string;
  accent: string;
  accentSoft: string;
  /** URL absoluta do portal (outro deploy). */
  href: string;
}

/**
 * Fallback de desenvolvimento — as portas locais de cada app (vite.config.ts).
 */
const DEV_FALLBACK: Record<PortalKey, string> = {
  paciente: 'http://localhost:5173',
  empresa: 'http://localhost:5174',
  cobranca: 'http://localhost:5175',
  admin: 'http://localhost:5176',
};

/**
 * Constrói os links do seletor de portais a partir dos dados compartilhados.
 *
 * Diferente do protótipo (SPA único que troca o portal em memória), aqui cada
 * portal é uma **solução isolada / deploy separado** — então o seletor NAVEGA
 * entre apps. As URLs de produção vêm de variáveis de ambiente do Vite
 * (`VITE_PORTAL_URL_PACIENTE`, `VITE_PORTAL_URL_EMPRESA`, …); em dev, caem para
 * `localhost` nas portas de cada app.
 */
export function defaultPortalLinks(): PortalLink[] {
  const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {};
  const url = (k: PortalKey) => env[`VITE_PORTAL_URL_${k.toUpperCase()}`] || DEV_FALLBACK[k];

  return portalOrder.map((k) => {
    const p = portals[k];
    return {
      id: p.id,
      name: p.name,
      sub: p.sub,
      accent: p.accent,
      accentSoft: p.accentSoft,
      href: url(k),
    };
  });
}
